import React from 'react';
import styled from 'styled-components';
import { Container } from '../styles/components';
import Logo from './Logo';

const FooterWrapper = styled.footer`
  padding: ${props => props.theme.spacing.xl} 0;
  background: ${props => props.theme.colors.charcoal};
  color: ${props => props.theme.colors.bone};
  border-top: ${props => props.theme.borders.widths.thin} solid ${props => props.theme.colors.border};
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: ${props => props.theme.spacing.lg};

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    text-align: center;
    gap: ${props => props.theme.spacing.xl};
    
    > * {
      justify-self: center;
    }
  }
`;

const LeftColumn = styled.div`
  display: flex;
  justify-content: flex-start;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    justify-content: center;
    order: 2;
  }
`;

const MiddleColumn = styled.div`
  text-align: center;
  font-size: ${props => props.theme.typography.sizes.caption};
  opacity: 0.8;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    order: 3;
  }
`;

const RightColumn = styled.div`
  display: flex;
  justify-content: flex-end;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    justify-content: center;
    order: 1;
  }
`;

const LinkedInLink = styled.a`
  color: ${props => props.theme.colors.bone};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity ${props => props.theme.transitions.default};

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <FooterGrid>
          <LeftColumn>
            <LinkedInLink
              href="https://www.linkedin.com/in/ellierofe/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </LinkedInLink>
          </LeftColumn>

          <MiddleColumn>
            © 2025 Copyright. Rofe Consulting Ltd t/a 'Nicely Put'. All Rights Reserved.
          </MiddleColumn>

          <RightColumn>
            <Logo reversed={true} size="32px" />
          </RightColumn>
        </FooterGrid>
      </Container>
    </FooterWrapper>
  );
};

export default Footer; 